import { Grid, Typography } from '@mui/material';
import moment from 'moment';
import React from 'react';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  heading: {
    fontSize: '17px !important',
    fontWeight: '500',
    color: '#333333',
  },
  lables: {
    fontSize: '13px !important',
    fontWeight: '500',
    color: '#333333',
    marginRight: '20px',
    marginLeft: '3px',
  },
  gridContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    minWidth: '500px',
    maxWidth: '500px',
    paddingBottom: '24px',
  },
}));

export const CurrentDates = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const moveInDate: string = useWatch({ name: 'moveInDate' });
  const moveOutDate: string = useWatch({ name: 'moveOutDate' });

  const formatDate = (date: string) => (date ? moment(date).format('MM/DD/YYYY') : null);

  return (
    <>
      <Grid container spacing={4} className={classes.gridContainer}>
        <Grid xs={12} item>
          <Typography component="span" className={classes.heading}>
            {`${t('placement.placementMods.currentDates')}`}
          </Typography>
        </Grid>
        <Grid xs={6} item sx={{ paddingTop: '10px !important' }}>
          <Typography component="span" className={classes.lables}>
            {`${t('placement.placementMods.moveIn')}`}
          </Typography>
          <Typography component="span"> {formatDate(moveInDate)}</Typography>
        </Grid>
        <Grid xs={6} item sx={{ paddingTop: '10px !important' }}>
          <Typography component="span" className={classes.lables}>
            {`${t('placement.placementMods.moveOut')}`}
          </Typography>
          <Typography component="span"> {formatDate(moveOutDate)}</Typography>
        </Grid>
      </Grid>
    </>
  );
};
